import { memo } from "react";
import Tooltip from "@mui/material/Tooltip";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import "./AjudaCard.scss";

/**
 * O ponto de interrogação ao lado do título de uma card da dashboard.
 *
 * A explicação vem de FORA, como conteúdo: cada card sabe o que mostra, e o
 * texto deve viver ao lado dos números que descreve — não numa lista central
 * que ninguém se lembra de atualizar quando a conta muda.
 *
 * `tabIndex` e `enterTouchDelay` existem por razões diferentes: o primeiro para
 * se chegar lá pelo teclado (um `svg` não recebe foco sozinho), o segundo
 * porque por omissão o MUI só mostra o tooltip ao fim de 700ms de toque, e no
 * telefone parece que o ícone não faz nada.
 */
function AjudaCard({ children, titulo = "Ajuda" }) {
  return (
    <Tooltip
      title={<div className="ajuda-card__conteudo">{children}</div>}
      arrow
      enterTouchDelay={0}
      leaveTouchDelay={8000}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 360,
            backgroundColor: "#37474f",
            fontSize: "0.78rem",
            lineHeight: 1.5,
            padding: "10px 12px",
          },
        },
        arrow: { sx: { color: "#37474f" } },
      }}
    >
      <span className="ajuda-card" tabIndex={0} role="button" aria-label={titulo}>
        <HelpOutlineIcon className="ajuda-card__icone" />
      </span>
    </Tooltip>
  );
}

export default memo(AjudaCard);
